import type { ConstructionTypeQuoteFormInput } from 'app/home/create-quote/forms/property-details/construction-type/construction-type.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function constructionTypeQuoteFormSelector(store: QuoteDraftSelectorState): ConstructionTypeQuoteFormInput {
  const constructionType = store.constructionType();
  return { constructionType };
}

export function constructionTypeQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['construction-type']();
}
